// extracted by mini-css-extract-plugin
export var featuredMediaContainer = "FeaturedMedia-module--featured-media-container--dj2g5";